import script from "./addNewCustomer.vue?vue&type=script&setup=true&lang=js"
export * from "./addNewCustomer.vue?vue&type=script&setup=true&lang=js"

import "./addNewCustomer.vue?vue&type=style&index=0&id=14baf7ba&scoped=true&lang=less"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14baf7ba"]])

export default __exports__